<section class="storyblok-blok-container">
  <div
    class="brand-list"
    [ngClass]="{ 'brand-list-white-bg': !allBrandsHaveLogos }"
    appIsVisible
    (isVisible)="initializeBrandListView()"
  >
    <div class="brand-list__title-area">
      <h2>{{ 'SHARED.BRAND_LIST.HEADLINE' | translate }}</h2>
      <p *ngIf="!isMobile">
        {{ 'SHARED.BRAND_LIST.SUBLINE' | translate }}
      </p>
    </div>
    <ng-container *ngTemplateOutlet="allBrandsHaveLogos ? brandLogos : brandNames"></ng-container>

    <ng-template #brandLogos>
      <app-brand-logos
        [brands]="displayedBrands"
        [isMobile]="isMobile"
        [getBrandPath]="getBrandPath"
        (onBrandClickGAEvent)="onBrandClickGAEvent($event)"
      ></app-brand-logos>
    </ng-template>
    <ng-template #brandNames>
      <app-brand-names
        [brands]="displayedBrands"
        [isMobile]="isMobile"
        [getBrandPath]="getBrandPath"
        (onBrandClickGAEvent)="onBrandClickGAEvent($event)"
      ></app-brand-names>
    </ng-template>
  </div>
</section>
